module.exports = __webpack_public_path__ + "media/assets/icons/ic-text-rich-7a0a6292a2977a99407ba87329297d82.svg";